import React from 'react';

import './PlaceholderUp.scss';

const PlaceholderUp = ({ label }) => (
  <span className="placeholder-up">{label}</span>
);

export default PlaceholderUp;
